module.exports = __webpack_public_path__ + "fonts/Outfit-Regular.9f444021.ttf";